import { Fragment } from 'react';
import { NewlineIcon } from '@ui/kit/icons';
import { CharacterInput } from './input.character.js';
import { lineBreak, whitespace, newlineIndicator } from './util.map-words-to-elements.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * maps data to actual JSX while inserting newlines + icon whenever a word is
 * split into multiple lines.
 */
function mapWordsToElements(words, args) {
  const characterWidthInPx = args.isMobile ? 46 : 56;
  const amountOfCharactersThatCanFitOnOneLine = args.containerWidth ? Math.floor(args.containerWidth / characterWidthInPx) : Infinity;
  let characterOffsetInCurrentLine = 0;
  return words.map((it, index) => {
    switch (it.nodeType) {
      case "word":
        {
          const word = it.characters.map((char, ci) => {
            const offset = characterOffsetInCurrentLine;
            let willRenderNewlineIcon = offset > 0 && offset % (amountOfCharactersThatCanFitOnOneLine - 1) === 0;
            if (willRenderNewlineIcon) {
              characterOffsetInCurrentLine = 1;
            } else {
              characterOffsetInCurrentLine += 1;
            }
            if (willRenderNewlineIcon && ci === it.characters.length - 1) {
              characterOffsetInCurrentLine = 0;
              willRenderNewlineIcon = false;
            }
            return /*#__PURE__*/jsxs(Fragment, {
              children: [willRenderNewlineIcon && (ci === 0 ? /*#__PURE__*/jsx("span", {
                className: whitespace,
                children: " "
              }, index) : /*#__PURE__*/jsx("span", {
                className: newlineIndicator,
                children: /*#__PURE__*/jsx(NewlineIcon, {})
              })), /*#__PURE__*/jsx(CharacterInput, {
                taskEntryKey: args.taskEntryKey,
                node: char
              })]
            }, `${index}-${ci}`);
          });
          return word;
        }
      case "mark-characters-whitespace":
        {
          // NB: Per new design spec we always parse whitespace as newlines
          const whitespaceType = "newline"; // args.isMobile ? "newline" : it.as;

          if (characterOffsetInCurrentLine === 0 && whitespaceType === "space") {
            return null;
          }
          {
            characterOffsetInCurrentLine = 0;
          }
          return /*#__PURE__*/jsx("span", {
            className: lineBreak,
            children: " "
          }, index);
        }
    }
  });
}

export { mapWordsToElements };
//# sourceMappingURL=util.map-words-to-elements.js.map
